import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    inputData: {}
  },
  mutations: {
    UPDATE_INPUTS(state, data) {
      state.inputData = data;
    },
  },
  actions: {
  },
  modules: {
  }
})
